import { Box, Container } from '@mui/material';
import React, { Suspense } from 'react';
import { COLOR_CODE } from 'src/appConfig/constants';
import { LoadingCommon } from 'src/components/common';
import BreadcrumbsSearchAllDocument from './breadcrumbsSearchAllDocument';

const TableMiscellaneousTableList = React.lazy(() => import('./TableSearch'));

const MiscellaneousSearchTable = () => {
  return (
    <Box py={2} minHeight={'50vh'}>
      <Container maxWidth="xl">
        <BreadcrumbsSearchAllDocument />
        <Box
          px={4}
          pt={2}
          pb={1}
          mt={2}
          bgcolor={'white'}
          border={COLOR_CODE.DEFAULT_BORDER}
          borderRadius={1}
        >
          <Suspense fallback={<LoadingCommon />}>
            <TableMiscellaneousTableList />
          </Suspense>
        </Box>
      </Container>
    </Box>
  );
};

export default MiscellaneousSearchTable;
